export default "__VITE_ASSET__D4L6$lcR__"